import { Props as FooterCardProps } from '../ContentModules/footerCardMapper';
import { mapLinks } from '../DataTypes/linkMapper';

export interface Props {
	items: { content: FooterCardProps['content']; settings?: Content.ContentModule['settings'] }[];
}

export const mapFooterCardList = ({ items }: Props): Content.FooterCardList => {
	const cardsArray = Array.isArray(items) ? items : [];
	return {
		documentType: 'footerCardList',
		content: {
			cards: cardsArray
				.filter((card) => !!card?.content)
				.map(({ content: card }) => {
					const { heading, text, links } = card?.properties ?? {};
					const footerCard: Content.FooterCard = {
						documentType: 'footerCard',
						content: {
							heading: heading || null,
							text: text?.markup || null,
							links: mapLinks(links) || null,
						},
					};
					return footerCard;
				}),
		},
	};
};
